type Visit = {
  key?: string;
  token?: string;
  title?: string;
  prohibit_background_showcase?: boolean;
  region_id?: number | string;
  equals_country_region_site?: boolean;
  device_platform_alias?: string;
  ads_use_custom?: string;
  ads_key_custom?: string;
  use_alternative_settings?: boolean;
  sms_confirmation?: boolean;
  telephone?: string;
};

const TRAFFIC_SOURCE_PARAMETERS = new Set([
  "utm_source",
  "from_url",
  "utm_medium",
  "any_param",
  "subid",
  "transaction_id",
  "tr_id",
  "click_id",
  "ClickHash",
  "utm_term",
]);

export default async () => {
  const cookies = getCookies();

  const url = window.location.href;
  const keys = [...new URL(url).searchParams.keys()];

  const hasParameters = keys.some((key) => TRAFFIC_SOURCE_PARAMETERS.has(key));
  const isNewUrl = url !== cookies.from_url;
  const needCreateVisit = !cookies.pre_token || (isNewUrl && hasParameters);

  if (!needCreateVisit) return;

  const response = await $fetch<Visit>("/api/help/parse-source-from-url", {
    baseURL: "",
    method: "POST",
    body: { url },
    signal: useAbortTimeout(),
  });

  for (const key in response) {
    if (Object.prototype.hasOwnProperty.call(response, key)) {
      const element = response[key as keyof Visit];

      if (!element) response[key as keyof Visit] = undefined;
    }
  }

  const token = useRoute().query.token as string;

  if (token) {
    cookies.validationToken = token;
    cookies.showValidationToken = true;

    cookies.registrationToken = token;
    cookies.user_token = token;
  }

  cookies.pre_token = response.token;
  cookies.source_key = response.key;
  cookies.use_alternative_settings = response.use_alternative_settings;
  cookies.sms_confirmation = response.sms_confirmation;
  cookies.prohibit_background_showcase = response.prohibit_background_showcase;
  cookies.adaptive_title = response.title;
  cookies.region_id = response.region_id;
  cookies.equals_country_region_site = response.equals_country_region_site;
  cookies.custom_platform_alias = response.ads_use_custom;
  cookies.custom_platform_account_id = response.ads_key_custom;
  cookies.device_platform_alias = response.device_platform_alias?.toLowerCase();
  cookies.telephone = response.telephone;
  cookies.from_url = url;
};
